'use client';

import React, { useEffect } from 'react';
import { loadTokenSetFromLocalStorage } from '@/slices/features/localStorage/tokenStoreLocalStorage';
import { setInitialTokenSet, checkAndHandleTokenExpiry } from '@/slices/features/tokenSet/tokenSetSlice';
import { useAppDispatch } from '@/slices/hooks';
import { useAuthenticated } from '@/hooks/useAuthenticated';
import { useAccount } from '@/hooks/useAccount';

interface StoreInitializerProps {
  children: React.ReactNode;
}

export default function StoreInitializer({ children }: StoreInitializerProps) {
  const dispatch = useAppDispatch();
  const { isAuthenticated, isLoading } = useAuthenticated();
  const { loadAllAccountData } = useAccount();

  useEffect(() => {
    const tokenSet = loadTokenSetFromLocalStorage();
    if (tokenSet) {
      dispatch(setInitialTokenSet(tokenSet));
      dispatch(checkAndHandleTokenExpiry());
    }
  }, [dispatch]);

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      loadAllAccountData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isAuthenticated, isLoading]);

  return <>{children}</>;
}
